import { FormattedResolvedEntityV3Data } from '@terminal/stores/use-watchlist/entityResolver';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface UseAlertMessageProps {
  resolvedEntityData: FormattedResolvedEntityV3Data;
  allDuplicateTickers: string[];
}

export const useAlertMessage = ({
  resolvedEntityData,
  allDuplicateTickers,
}: UseAlertMessageProps) => {
  const { t } = useTranslation(['watchlistManager', 'widget']);
  const [message, setMessage] = useState('');
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    if (isError) {
      setMessage(t('widget:watchlist.watchlistEmptyMessage'));
    } else if (resolvedEntityData.entities.length) {
      const tagsCount = resolvedEntityData.tags.length;
      const inputCount = resolvedEntityData.entities.length;

      const countOfLabel = t('watchlistManager:alertMessage.countOf', {
        countFound: tagsCount,
        count: inputCount,
      });
      const mappedLabel = t('watchlistManager:alertMessage.mapped', {
        count: tagsCount,
      });

      if (allDuplicateTickers.length > 0) {
        const duplicatesLabel = t(
          'watchlistManager:alertMessage.mappedWithDuplicates',
          {
            count: allDuplicateTickers.length,
            tickers: allDuplicateTickers.join(', '),
          }
        );
        setMessage(`${countOfLabel}${mappedLabel}${duplicatesLabel}`);
      } else if (resolvedEntityData.entities.length) {
        setMessage(`${countOfLabel}${mappedLabel}`);
      }
    }
  }, [isError, resolvedEntityData]);

  useEffect(() => {
    const id = setTimeout(() => {
      if (message) {
        setMessage('');
      }
    }, 5000);

    return () => {
      clearTimeout(id);
    };
  }, [message]);

  return {
    alertMessage: {
      message,
      isError,
    },
    setMessage,
    setIsError,
  };
};
